import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Data, Route, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from 'src/app/providers/common-data.service';
import { Helper_Class } from 'src/app/helper_class';
import { PharmacyService } from '../pharmacy/pharmacy.service';
import { ipaddress } from '../../ipaddress';
import { pharmacy_helper } from '../Pharmcy_Helper';
import { Message_data } from 'src/assets/js/Message_data';

@Component({
  selector: 'app-pharma-supplier-mst',
  templateUrl: './pharma-supplier-mst.component.html',
  styleUrls: ['./pharma-supplier-mst.component.css']
})
export class PharmaSupplierMstComponent implements OnInit {
  public sendData
  private pharmacyID;
  public supplerIndex;
  supplerMasterArray = [];
  public countryArray = [];
  public cityArray = [];
  public stateArray = [];
  public supplierState: any;
  public supplierCity: any;
  public supplierTelephone: any;
  public supplierMobile: any;
  public countryID: string;
  public supplierName: string;
  public supplierCode: string;
  public suppliergst: string;
  public supplierAddress1: string;
  public supplierAddress2: string;
  public supplierCountry: any;
  public get: string;
  public supplyData;
  public suppID = "0";
  public PharmauserID;
  public add: any;
  public address1;
  public address2;
  public mgfValue;
  tempArray: any = []
  //mdbTable
  dtOptions: DataTables.Settings = {};
  public imei;
  public hospitalid;
  public userinfo;
  public showSupplierFlag: boolean;
  public saveFlag: boolean = true;
  public creditdays;
  public refil_dur;
  
  country(arg0: any): any {
    throw new Error("Method not implemented.");
  }

  constructor(public comm_Data: CommonDataService, public toastr: ToastrService, public http: Http, public router: Router, public dialog: MatDialog, public messageservice: PharmacyService) {
  }

  ngOnInit(): void {
    this.showSupplierFlag = pharmacy_helper.getSupplier() == true ? false : true;
    this.userinfo = Helper_Class.getInfo();
    this.hospitalid = this.userinfo.hospitals[0].hptl_clinic_id;
    this.supplierCountry = this.userinfo.hospitals[0].country;
    this.supplierCity = this.userinfo.hospitals[0].city;
    this.supplierState = this.userinfo.hospitals[0].state;
    this.imei = Helper_Class.getIPAddress();
    this.PharmauserID = this.userinfo.user_id;
    this.dtOptions = {
      pagingType: 'simple_numbers_no_ellipses',
      pageLength: 10,
      "lengthMenu": [[5, 10, 25, 50, -1], [5, 10, 25, 50, "All"]],
      "columnDefs": [
        { "orderable": false, "targets": [8] },
      ],
      "language": {
        "search": "<img src='../../../assets/img/search.png' width='18px'/>",
        searchPlaceholder: "Search by name, code, or address"
      },
      dom: '<"row"<"col-sm-6 col-xs-12"f><"col-sm-6 col-xs-12 d-flex justify-content-end"l>><"table-responsive"t><"row mt-1 d-flex"<"col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 pad_top_10"><"col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 text-center sm-order-last"i><"col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center"p>>'
    };
    this.getCountry();
    this.supplerMaster();
  }

  supplerMaster() { //Retrival Table data
    this.supplerMasterArray = [];
    this.supplerIndex = 0;
    this.sendData = JSON.stringify({
      pharmacist_id: this.PharmauserID,
      pharmacy_id: this.hospitalid,
      imei: this.imei,
    })
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + 'pharmacontrol/gsupp/', this.sendData,
      { headers: headers })
      .subscribe(
        data => {
          var obj = data.json();
          if (obj.suppliers != null) {
            for (var i = 0; i < obj.suppliers.length; i++) {
              var add_txt = obj.suppliers[i].address2 != null && obj.suppliers[i].address2 != undefined ? obj.suppliers[i].address1 + "," + obj.suppliers[i].address2 : obj.suppliers[i].address1;
              this.supplerMasterArray.push({
                Index: this.supplerIndex,
                name: obj.suppliers[i].name,
                supp_code: obj.suppliers[i].supp_code,
                gst_no:obj.suppliers[i].gst_no,
                address: add_txt,
                city_desc: obj.suppliers[i].city_desc,
                state_desc: obj.suppliers[i].state_desc,
                country_desc: obj.suppliers[i].country_desc,
                telephone: obj.suppliers[i].telephone,
                mobile: obj.suppliers[i].mobile,
                supp_id: obj.suppliers[i].supp_id,
                city: obj.suppliers[i].city,
                state: obj.suppliers[i].state,
                country: obj.suppliers[i].country,
                creditdays:obj.suppliers[i].creditdays,
                refil_dur:obj.suppliers[i].refil_dur,
              });
              this.supplerIndex++;
            }
            this.tempArray = this.supplerMasterArray;
          }
        },
        error => { });
  }

  getCountry() { //code for get country
    this.http.get(ipaddress.getIp + "usercontroller/count/").subscribe(
      data => {
        if (data.json().countries != null) {
          this.countryArray = data.json().countries;
          this.getState(this.supplierCountry, '1', this.supplierState);
        }
      },
      error => { });
  }

  getState(country, flag, state) { //code for get state
    this.stateArray = [];
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "usercontroller/state/", JSON.stringify({ country_id: country }), { headers: headers }).subscribe(
      data => {
        if (data.json().states != null) {
          this.stateArray = data.json().states;
          if (flag != null && flag == "1") { // Retrival
            this.stateArray.forEach(stateid => {
              if (stateid.state_id == state) {
                this.supplierState = stateid.state_id;
                this.getCity(this.supplierState, '1');
              }
            });
          }
        }
      },
      error => { });
  }

  getCity(state, flag) { //code for get city
    this.cityArray = [];
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "usercontroller/city/", JSON.stringify({ state_id: state }), { headers: headers }).subscribe(
      data => {
        if (data.json().cities != null) {
          this.cityArray = data.json().cities;
          if (flag != null && flag == '1') {
            this.cityArray.forEach(element => {
              if (element.district_id == this.supplierCity)
                this.supplierCity = element.district_id;
            });
          }
        }
      },
      error => { });
  }

  clickSupplerMaster() { //Add Table
    this.supplyData = [];
    this.saveFlag = true;
    if (this.supplierName == undefined || this.supplierName == "" || this.supplierCode == undefined
      || this.supplierCode == "" || this.supplierAddress1 == undefined || this.supplierAddress1 == ""
      || this.supplierCountry == undefined || this.supplierCountry == "" || this.supplierState == undefined
      || this.supplierState == undefined || this.supplierCity == undefined || this.supplierCity == undefined) {
      this.toastr.error(Message_data.mandatory);
    } else {
      var sup_flag = true;
      if (this.supplerMasterArray.length != 0) {
        for (var i = 0; i < this.supplerMasterArray.length; i++) {
          if (this.supplerMasterArray[i].supp_code == this.supplierCode) {
            sup_flag = false;
            break;
          }
        }
      }
      var add_txt = undefined;
      if (sup_flag == true) {
        if (this.supplierAddress2 != undefined && this.supplierAddress2 != "") {
          add_txt = this.supplierAddress2;
        }
        this.supplyData = ({
          name: this.supplierName,
          supp_code: this.supplierCode,
          gst_no:this.suppliergst,
          address1: this.supplierAddress1,
          address2: add_txt,
          country: this.supplierCountry,
          state: this.supplierState,
          city: this.supplierCity,
          telephone: this.supplierTelephone,
          mobile: this.supplierMobile,
          pharmacy_id: this.hospitalid,
          supp_id: this.suppID,
          creditdays:this.creditdays,
          refil_dur:this.refil_dur,
        });
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post(ipaddress.getIp + "pharmacontrol/ssupp/", this.supplyData, { headers: headers }).subscribe(
          data => {
            if (data.json().key == "1") {
              this.toastr.success(Message_data.suppDetAddedSuccess);
              this.saveFlag = false;
              if (pharmacy_helper.getSupplier() == true) {
                if (pharmacy_helper.getProductMst() != undefined) {
                  pharmacy_helper.getProductMst().supp_id = data.json().supp_id;
                  this.messageservice.sendMessage("product");
                }
              }
              this.supplierName = "";
              this.supplierCode = "";
              this.suppliergst="";
              this.supplierAddress1 = "";
              this.supplierAddress2 = "";
              this.supplierTelephone = "";
              this.supplierMobile = "";
              this.supplierCountry = "";
              this.supplierState = "";
              this.supplierCity = "";
              this.supplerMaster();

            } else {
              this.saveFlag = true;
              this.toastr.error(Message_data.unableToSave);
            }
          },
          error => {
            this.saveFlag = true;
            this.toastr.error(Message_data.unableToSave);
          });
      }
    }
  }

  editSuppler(data) {
    for (var i = 0; i < this.supplerMasterArray.length; i++) {
      if (this.supplerMasterArray[i].Index == data) {
        var flag = true;
        var coun_id = null;
        this.suppID = this.supplerMasterArray[i].supp_id;
        if (this.suppID != "0") {
          var satte_txt = this.supplerMasterArray[i].state;
          var city_txt = this.supplerMasterArray[i].city;
          var supp_add = this.supplerMasterArray[i].address.split(',');
          this.supplierName = this.supplerMasterArray[i].name;
          this.supplierCode = this.supplerMasterArray[i].supp_code;
          this.suppliergst = this.supplerMasterArray[i].gst_no;
          this.creditdays = this.supplerMasterArray[i].creditdays;
          this.refil_dur = this.supplerMasterArray[i].refil_dur;
          this.supplierAddress1 = supp_add[0];
          this.supplierAddress2 = supp_add[1];
          this.supplierTelephone = this.supplerMasterArray[i].telephone;
          this.supplierMobile = this.supplerMasterArray[i].mobile;
          for (var j = 0; j < this.countryArray.length; j++) {
            if (this.countryArray[j].country_id == this.supplerMasterArray[i].country) {
              this.supplierCountry = this.countryArray[j].country_id;
              coun_id = this.countryArray[j].country_id;
              break;
            }
          }
          var headers = new Headers();
          headers.append('Content-Type', 'application/json');
          this.http.post(ipaddress.getIp + "usercontroller/state/", JSON.stringify({
            country_id: coun_id
          }), { headers: headers }).subscribe(
            data => {
              var obj = JSON.parse(data["_body"]);
              this.stateArray = [];
              this.cityArray = [];
              this.stateArray = obj.states;
              for (var j = 0; j < this.stateArray.length; j++) {
                if (this.stateArray[j].state_id == satte_txt) {
                  this.supplierState = this.stateArray[j].state_id;
                  var headers = new Headers();
                  headers.append('Content-Type', 'application/json');
                  this.http.post(ipaddress.getIp + "usercontroller/city/", JSON.stringify({
                    state_id: this.stateArray[j].state_id
                  }), { headers: headers }).subscribe(
                    data => {
                      var obj = JSON.parse(data["_body"]);
                      this.cityArray = [];
                      this.cityArray = obj.cities;
                      for (var j = 0; j < this.cityArray.length; j++) {
                        if (this.cityArray[j].district_id == city_txt) {
                          this.supplierCity = this.cityArray[j].district_id;
                          break;
                        }
                      }
                    },
                    error => { });
                  break;
                }
              }
            },
            error => { });
          this.supplerMasterArray.splice(i, 1);
        }
        
      }
    }
  }

  reset() {
    this.supplierName = "";
    this.supplierCode = "";
    this.suppliergst="";
    this.supplierAddress1 = "";
    this.supplierAddress2 = "";
    this.supplierCountry = "";
    this.supplierState = "";
    this.supplierCity = "";
    this.supplierTelephone = "";
    this.supplierMobile = "";
    this.supplerMaster();
  }
  
  back() {
    this.messageservice.sendMessage("product");
  }
}
